const propertiesSelector = state => state.properties

export const tokenExpirationSecondsSelector = state => propertiesSelector(state).tokenExpirationSeconds
export const passwordConfigSelector = state => propertiesSelector(state).password
